

import React from 'react';
import { AddonsConsumer } from '../../../../Addons';
import AdditionalOutputAddonViewComponent from '../components/AdditionalOutputAddonView';

function AdditionalOutputAddonView(props) {
  return (
    <AddonsConsumer>
      {({
        actions: { getAdditionalOutputs }
      }) =>
      <AdditionalOutputAddonViewComponent
        getAdditionalOutputs={getAdditionalOutputs}
        {...props} />}


    </AddonsConsumer>);

}

export default AdditionalOutputAddonView;